<template>
  <div class="users-list" v-loading="loading">
    <el-input placeholder="Поиск ..." v-model="search" class="input-search">
      <el-button slot="append" icon="el-icon-search"></el-button>
    </el-input>
    <div class="users-ul">
      <div
        :class="['users-li']"
        v-for="(user, index) in filteredList"
        @click="routerNavigate(user.uid)"
        :key="index"
      >
        <div>
          <div class="name">
            <span>{{ user.name }}</span>
            <small>{{ user.position || user.role }}</small>
          </div>
          <small class="company">{{ user.company ? `Компания: ${user.company}` : user.email }}</small>
        </div>
        <div @click="routerNavigate(user.uid)">
          <i class="fas fa-chevron-right"></i>
        </div>
      </div>
      <div class="users-invites" v-if="invites.length">
        <h5>Неподтвержденные приглашения</h5>
        <div
          :class="['users-li']"
          v-for="(user, index) in invites"
          :key="index"
        >
          <div>
            <div class="name">
              <span>{{ user.name }}</span>
              <small>{{ rules[user.role] }}</small>
            </div>
            <span class="email">{{ user.email }}</span>
          </div>
          <div class="users-controls">
            <i @click="getLink(user)" class="fa fa-link"></i>

            <i @click="deleteInvite(user.id)" class="fa fa-trash"></i>
          </div>
        </div>
      </div>


      <div class="users-ul" v-if="companies.length">
        <h5>Компании</h5>
        <div
          :class="['users-li']"
          @click="selectCompany(user)"
          v-for="(user, index) in companies"
          :key="index"
        >
          <div style="display: flex">
            <div @click.stop="routerNavigate(user.uid)">
              <i class="fa fa-edit"></i>
            </div>
            <div class="name" style="margin-left: 14px;">
              <span>{{ user.name }}</span>
            </div>
          </div>
          <div class="users-controls">
              <i class="fas fa-chevron-right"></i>
          </div>
        </div>
      </div>

      <div class="empty-users" v-if="!users.length && !invites.length && !loading">
        <el-alert
          title="Пользователи не найдены"
          type="warning"
          description="В вашем проекте пока отсутсвуют пользователи, но вы можете их добавить"
          show-icon
        >
        </el-alert>
      </div>

      <div class="controls">
        <router-link to="/dashboard/users/create" class=" add-user">
          <i class="el-icon-plus"></i>
          <span>Добавить пользователя</span>
        </router-link>
        <router-link to="/dashboard/users/project" class=" add-user">
          <i class="el-icon-plus"></i>
          <span>Загрузить из другого проекта</span>
        </router-link>
        <router-link to="/dashboard/users/create/company" class=" add-user">
          <i class="el-icon-plus"></i>
          <span>Добавить компанию</span>
        </router-link>
<!--        <router-link to="/dashboard/users/create" class=" add-user">-->
<!--          <i class="el-icon-plus"></i>-->
<!--          <span>Загрузить из файла</span>-->
<!--        </router-link>-->
      </div>
    </div>
  </div>
</template>

<script>
import AddProject from '@/views/Dashboard/Projects/components/AddProject';
import firebase from 'firebase';
import _ from 'lodash';
import {getPermission} from "../../../firestore/permission";

export default {
  name: 'List',
  components: {AddProject},
  data() {
    return {
      search: '',
      loading: false,
      users: [],
      invites: [],
      companies: [],
      rules: {
        'worker': 'Стандартный',
        'admin': 'Админ',
        'editor': 'Редактор',
      },
    };
  },

  mounted() {
    this.fetchInvite();
    this.fetchUsers();
  },

  methods: {
    getLink(user) {
      this.$alert(`https://stroybots-prod.web.app/#/?project=${this.$store.state.project.id}&token=${user.hash}`,
        'Ссылка для приглашения пользователя', {
          confirmButtonText: 'OK',
        });
    },
    selectCompany(company) {
      this.$confirm('Отчитаться по компании?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        localStorage.setItem('company', JSON.stringify(company));
        this.$store.dispatch('setCompany', company);
        this.$router.push('/dashboard/reports')
      });
    },
    routerNavigate(id) {
      this.$router.push('/dashboard/users/edit/' + id);
    },
    routerNavigateReports(id) {
      this.$router.push(`/dashboard/reports/${id}?isUser=true`);

    },
    async fetchUsers() {
      this.loader = true;
      const result = [];

      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .get()
        .then((data) => {

          data.forEach((subDoc) => {
            let _data = subDoc.data();

            result.push({..._data, id: subDoc.id});
          });
        }).finally(() => {
        this.users = _.uniqBy(result.filter((r) => !r.isCompany), 'email');
        this.companies = result.filter((r) => r.isCompany);
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    fetchInvite() {
      this.loader = true;
      const result = [];
      firebase.firestore()
        .collection('invites')
        .where('projectId', '==', this.$store.state.project.id)
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            let _data = subDoc.data();
            result.push({..._data, id: subDoc.id});
          });
        }).finally(() => {
        this.invites = result;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },

    deleteInvite(id) {
      this.$confirm('Вы действительно хотите удалить это приглашение?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        firebase.firestore()
          .collection('invites')
          .doc(id).delete()
          .then(() => {
            this.fetchInvite();
            this.$notify({
              offset: 60,

              title: 'Успешно!',
              message: 'Приглашение  удалено',
              type: 'success',
            });
          });
      });
    },
  },

  computed: {
    filteredList() {
      return this.users.filter(user => {
        return user.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
};
</script>

<style scoped lang="scss">
.users-list {
  max-width: 382px;
  width: calc(100% - 40px);
  margin: 22px auto;
}

.input-search {
  margin-top: 12px;
}

.name {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  small {
    font-size: 12px;
    font-weight: bold;
  }
}

.users-ul {
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .users-li, > > > .users-li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    height: 64px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    padding: 0 12px;


    &.active {
      background: rgba(54, 118, 203, 0.26) !important;
    }

    &:hover {
      background: #f0f0f0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.add-user {
  margin-top: 22px;
  text-decoration: none;
  color: #3676CB;

  &:hover {
    color: #222;
  }
}

.controls {
  margin-top: 30px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
}

.users-invites {
  margin-top: 20px;

  .name, .email {
    opacity: 0.5;
  }
}

.users-controls {
  display: flex;
  justify-content: flex-end;

  i {
    margin-left: 16px;
  }
}
</style>
<style>
.el-message-box__message {
  overflow-wrap: break-word !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Users/List.vue